export default __webpack_public_path__ + "static/media/8.d575d1d3.jpg";